import { getBooking } from "../../../app/api/getBooking";
import { removeVoucher } from "../../../app/api/manageVoucher";
import { BaseAction } from "../../../core/actions/BaseAction";
import { calculatePrice } from "../../../Lib/Utils/validationUtil";
import { toVoucherErrorKey } from "../../../Lib/Utils/voucherErrors";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IBookingResponse } from "../../../Orchestrator/Types/Index";
import { IRemovedVoucherCodeActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/VoucherActionParams";
import { prepareBookingSummaryAction } from "../Checkout/Summary/PrepareBookingSummaryAction";

export class RemoveVoucherCodeAction extends BaseAction<string, IRemovedVoucherCodeActionParams> {

    override async run(): Promise<string> {
        try {
            const { bookingId, voucherCode } = this.params!
            try {
                const response: any = await removeVoucher(bookingId, voucherCode);
                if (response.status === "ok") {
                    const bookingResponse: any = await getBooking(bookingId);
                    if (bookingResponse.status === "ok" && bookingResponse.answer) {
                        const { booking }: IBookingResponse = bookingResponse.answer

                        updateRecoilState("bookingResponseAtom", bookingResponse.answer)

                        const isOnHoldBooking = (booking?.bookedOffers || []).some(offer =>
                            (offer?.admissions || []).some(admission => admission?.status === "ON_HOLD")
                        )

                        prepareBookingSummaryAction.setParams({
                            ...booking,
                            ...(isOnHoldBooking ? { isFrom: "on-hold-booking" as const } : {})
                        })
                        await prepareBookingSummaryAction.execute()

                        const calculateVoucherAmount = booking.pendingVouchers.map(v => {
                            return {
                                ...v,
                                amount: {
                                    ...v.amount,
                                    amount: calculatePrice({ amount: v.amount.amount, scale: v.amount.scale, currency: "", vats: [] })
                                }
                            }
                        })
                        updateRecoilState("listOfAppliedVoucherAtom", calculateVoucherAmount)
                    }
                } else {
                    // This call raises no toast, so the inline message is the only feedback.
                    // Falls back to the generic error rather than "invalid voucher code":
                    // a 5xx blocking the removal says nothing about the voucher's validity.
                    updateRecoilState("voucherErrorAtom", toVoucherErrorKey(response.errorCode, "apiErrorMsg"))
                }
            } catch (error: any) {
                console.error("Error removing voucher", error);
            }
        } catch (error) {
            console.error("Error during my account action menu click:", error);
        } finally {
            return ""
        }
    }
}

export const removedVoucherCodeAction = new RemoveVoucherCodeAction();
